import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  const userRole = localStorage.getItem('userRole');
  
  const getRedirectPath = () => {
    switch(userRole) {
      case 'Student':
        return '/dashboard';
      case 'Consultant':
        return '/consultant/dashboard';
      case 'Admin':
        return '/admin/dashboard';
      case 'SalesPerson':
        return '/sales/crm';
      default:
        return "/signin";
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-800 mb-4">404</h1>
        <p className="text-2xl text-gray-600 mb-8">Page Not Found</p>
        <p className="text-gray-500 mb-8">
          The page you're looking for doesn't exist or you don't have permission
          to access it.
        </p>
        <Link
          to={getRedirectPath()}
          className="bg-[#1E3557] text-white px-6 py-3 rounded-lg"
        >
          {userRole === "SalesPerson"
            ? "Go Back to CRM"
            : "Go Back to Dashboard"}
        </Link>
      </div>
    </div>
  );
};

export default NotFound;